/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryReturnType,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FileInput,
  ListOwnImagesParams,
  PaginatedOwnImages,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List own images
 */
export const listOwnImages = (
    params?: MaybeRefOrGetter<ListOwnImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedOwnImages>(
      {url: `/own_images`, method: 'GET',
        params, signal
    },
      );
    }




export const getListOwnImagesInfiniteQueryKey = (params?: MaybeRefOrGetter<ListOwnImagesParams>,) => {
    return [
    'infinite', 'own_images', ...(params ? [params] : [])
    ] as const;
    }

export const getListOwnImagesQueryKey = (params?: MaybeRefOrGetter<ListOwnImagesParams>,) => {
    return [
    'own_images', ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnImagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listOwnImages>>, ListOwnImagesParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListOwnImagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData, QueryKey, ListOwnImagesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListOwnImagesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnImages>>, QueryKey, ListOwnImagesParams['page']> = ({ signal, pageParam }) => listOwnImages({...toValue(params), 'page': pageParam ?? toValue(params)?.['page']}, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData, QueryKey, ListOwnImagesParams['page']>
}

export type ListOwnImagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnImages>>>
export type ListOwnImagesInfiniteQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List own images
 */

export function useListOwnImagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listOwnImages>>, ListOwnImagesParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListOwnImagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData, QueryKey, ListOwnImagesParams['page']>>, }
 , queryClient?: QueryClient
 ): UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnImagesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export const getListOwnImagesQueryOptions = <TData = Awaited<ReturnType<typeof listOwnImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListOwnImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListOwnImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnImages>>> = ({ signal }) => listOwnImages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData>
}

export type ListOwnImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnImages>>>
export type ListOwnImagesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List own images
 */

export function useListOwnImages<TData = Awaited<ReturnType<typeof listOwnImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListOwnImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnImages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Copy an own image into cache storage
 */
export const copyOwnImage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<FileInput>(
      {url: `/own_images/${id}/copy`, method: 'POST', signal
    },
      );
    }




export const getCopyOwnImageMutationKey = () => ['copyOwnImage'] as const;

export const getCopyOwnImageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyOwnImage>>, TError,CopyOwnImageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof copyOwnImage>>, TError,CopyOwnImageMutationVariables, TContext> => {

const mutationKey = getCopyOwnImageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyOwnImage>>, CopyOwnImageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  copyOwnImage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyOwnImageMutationResult = NonNullable<Awaited<ReturnType<typeof copyOwnImage>>>

    export type CopyOwnImageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CopyOwnImageMutationVariables = {id: string}

    /**
 * @summary Copy an own image into cache storage
 */
export const useCopyOwnImage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyOwnImage>>, TError,CopyOwnImageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof copyOwnImage>>,
        TError,
        CopyOwnImageMutationVariables,
        TContext
      > => {
      return useMutation(getCopyOwnImageMutationOptions(options), queryClient);
    }
